import './index.scss';
import { Button } from 'ii-react-sdk/form_components';
import React from 'react';
import useComponentVisible from '~/hooks/useComponentVisible';
const DocSelect = ({ document, icon, setDocument, state }) => {
    var _a;
    const { ref: showHideRef, isComponentVisible: isDocSelectOpen, setIsComponentVisible: setIsDocSelectOpen, } = useComponentVisible(false);
    if (!state.anchorDoc || !state.comparatorDoc)
        return null;
    const toggleDocsDisplay = () => {
        if (!state.anchorHasRendered || !state.comparatorHasRendered)
            return;
        setIsDocSelectOpen(!isDocSelectOpen);
    };
    return (React.createElement("div", { className: 'document-filter' },
        React.createElement("div", { className: 'header document-title', "data-testid": 'document-title', onClick: () => toggleDocsDisplay() },
            (!state.anchorHasRendered || !state.comparatorHasRendered) &&
                React.createElement("div", { className: 'panel-overlay' }),
            React.createElement("span", { className: 'icon' },
                React.createElement("i", { className: icon })),
            React.createElement("span", { className: 'document-title overflow-ellipsis' }, document === null || document === void 0 ? void 0 : document.fileName),
            isDocSelectOpen && (React.createElement("div", { className: 'document-switch-dropdown', "data-testid": 'document-switch-dialog', ref: showHideRef }, (_a = state.comparisonDocuments) === null || _a === void 0 ? void 0 : _a.map((doc, index) => {
                const isSelectedDoc = doc.documentComparisonFileId === (document === null || document === void 0 ? void 0 : document.documentComparisonFileId);
                return React.createElement("div", { "data-testid": `doc-compare-switcher-doc-${index}`, key: `${doc.documentComparisonFileId}-document-select`, className: 'select-item', onClick: () => setDocument(doc.documentComparisonFileId) },
                    React.createElement("span", { className: 'icon' }, isSelectedDoc &&
                        React.createElement("i", { className: icon })),
                    React.createElement("span", { className: 'overflow-ellipsis', title: doc.fileName }, doc.fileName));
            })))),
        React.createElement(Button, { className: 'doc-swap-button', onClick: state.swapDocs, disabled: !state.anchorHasRendered || !state.comparatorHasRendered },
            React.createElement("i", { className: 'fas fa-exchange' }))));
};
export default DocSelect;
